import { Component, OnInit } from '@angular/core';
import { MyauthService } from 'src/app/services/myauth.service';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { Router } from '@angular/router';

@Component({
  selector: 'app-signup',
  templateUrl: './signup.component.html',
  styleUrls: ['./signup.component.css']
})
export class SignupComponent implements OnInit {

  exampleForm: FormGroup;
  validation_messages = {
    'uname': [
      { type: 'required', message: 'E-mail is required!' }
    ],
    'pwd': [
      { type: 'required', message: 'Password is required!' }
    ]
  };

  constructor(private myauth:MyauthService, private router:Router, private fb: FormBuilder) { }

  goSignUp(value){
    this.myauth.SignUp(value.uname, value.pwd);
  }

  goSignIn(){
    this.router.navigateByUrl('signin');
  }

  ngOnInit(): void {
    this.createForm();
  }
  
  createForm(){
    this.exampleForm = this.fb.group({
      uname: ['', Validators.required ],
      pwd: ['', Validators.required ]
    });
  }

}
